import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgComponent() {
  return (
    <Svg
      width={17}
      height={17}
      viewBox="0 0 17 17"
      fill="none"
    >
      <Path
        d="M.935 4.557l.032-.019L7.56.691.935 4.557zm0 0v.037m0-.037v.037m0 0V12.444m0-7.85v7.85m0 0l.032.018m-.032-.018l.032.018m0 0l6.591 3.847-6.59-3.847zm15.098-.018l-.032.018L9.44 16.31l6.624-3.866zm0 0v-.038m0 .038v-.038m0 0V4.557m0 7.85v-7.85m0 0l-.032-.019m.032.02l-.032-.02m0 0L9.442.691a1.861 1.861 0 00-1.883 0l8.474 3.847zM8.5 16.565c-.326 0-.651-.085-.942-.256l.942.256zm0 0c.326 0 .65-.085.941-.255l-.941.255zm-.525-15.19h0c.324-.191.727-.192 1.051 0h0l5.839 3.407L8.5 8.501 2.135 4.784l5.84-3.41zm.12 7.816v6.49a.765.765 0 01-.12-.056h0L1.746 11.99V5.484l6.347 3.707zm.93 6.434h0a.775.775 0 01-.12.056V9.192l6.348-3.707v6.505l-6.227 3.635z"
        stroke="#434BFF"
        strokeWidth={0.6}
      />
    </Svg>
  )
}

export default SvgComponent
